import { buildQueryString } from '../helpers/Utils';

class Journeys {
  /**
   * Constructs a new instance of this class
   *
   * @param api {API}
   */
  constructor(api) {
    this.api = api;
  }

  list(query) {
    query = query || {};
    const queryString = buildQueryString(query);

    return this.api.fetchJson('/api/journeys/' + queryString);
  }
}

export default Journeys;
